<div class="tab my_organized">
  <ui-campaign-profile-tabs [campaigns]="(campaigns)"></ui-campaign-profile-tabs>
</div>